import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Privacy() {
  const { t } = useTranslation();
  return (
    <section className="section-pad">
      <div className="container-zt" style={{ maxWidth: 860 }}>
        <div className="eyebrow">Zantravina · Legal</div>
        <h1 className="font-display" style={{ fontSize: 'clamp(36px, 5vw, 60px)', lineHeight: 1.05, marginTop: 12 }}>{t('privacy.title')}</h1>
        <p style={{ marginTop: 12, color: 'var(--stone)', fontSize: 14 }}>{t('privacy.updated')}</p>
        <div className="legal-doc" style={{ marginTop: 32 }}>
          <p>{t('privacy.intro')}</p>
          {[1,2,3,4,5,6,7,8,9,10].map((i) => (
            <div key={i}>
              <h2>{t(`privacy.s${i}Title`)}</h2>
              <p>{t(`privacy.s${i}Text`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
